export default __webpack_public_path__ + "static/media/mandrill.ed597fa7.svg";